import { Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface FlexspendStoreState {
}

export default {
  state: {

  },

  actions: {
    async getReportsList({}, payload) {
      const endpoint = 'flexspend/get-flexspend-report';
      return ApiServiceWrapper.post(endpoint , payload);
    },

    async getFlexspendDetails({}) {
      const endpoint = 'flexspend/get-flexspend-details';
      return ApiServiceWrapper.get(endpoint);
    },
  },
  namespaced: true,
} as Module<FlexspendStoreState, RootStoreState>;
